import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useDeleteClasse() {
  return useMutation(URL.CLASSES_OPERACAO.DELETAR("id"), async (id: string) => {
    const response = await http.delete(URL.CLASSES_OPERACAO.DELETAR(id));
    return response;
  });
}

export default useDeleteClasse;
